/**
 * PR-CWJ-01 — Unified Task Engine types
 *
 * Canonical task state machine for Chat, Code, Cowork, Voice, Mobile, Web,
 * Desktop and Automation inputs. No real tool execution happens inside this
 * engine; it only tracks state, validates transitions, enforces isolation,
 * and emits audit events.
 */
export class CwjTaskEngineError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "CwjTaskEngineError";
    }
}
//# sourceMappingURL=types.js.map